<template>
  <EventReviewSection :title="sectionTitle" />
</template>

<script setup>
import { computed } from "vue";
import EventReviewSection from "./EventReviewSection.ce.vue";
import { t } from "#ce/components/SpCheckout/i18n";

const sectionTitle = computed(() => t("review_cart_section_title"));
</script>
